import { parseZone, type DatetimeType } from '@common/services/datetime';

import { HourEntryFragment } from '@common/graphql/schema';

export const parseInTz = (date: string, tz?: string | null): DatetimeType =>
  tz ? parseZone(date).tz(tz) : parseZone(date);

export const maybeParseInTz = (
  date: string | undefined | null,
  tz?: string | null
): DatetimeType | undefined => {
  if (!date) {
    return;
  }

  return parseInTz(date, tz);
};

export const parseHourEntryDates = (entry: HourEntryFragment) =>
  [
    parseInTz(entry.startedAt!, entry.startedAtTz),
    parseInTz(entry.endedAt!, entry.endedAtTz),
  ] as const;

export const withMinutesPrecision = (date: DatetimeType | undefined) =>
  date?.second(0)?.millisecond(0);

// NOTE: `tz(zone, true)` keeps the picked wall clock and re-resolves the offset there, so a
// shift on a DST-transition day spans the hours it is actually paid.
export const atFacilityZone = (
  clock: DatetimeType | undefined,
  facilityTz: string | undefined | null
) => clock?.tz(facilityTz || 'UTC', true);

export const isOutsideDateRange = (
  date: DatetimeType,
  min: DatetimeType | undefined,
  max: DatetimeType | undefined
) => {
  if (!min || !max) {
    return false;
  }

  return date.isBefore(min, 'date') || date.isAfter(max, 'date');
};
